export const getItemFromLocalStorage = (itemKey) => {
  if (itemKey) {
    return window.localStorage.getItem(itemKey);
  }

  return null;
};
